<template>
  <div class="counter">
    <div class="qrs">
      <!-- <div style="margin-bottom: 20px">
        <el-button type="primary" @click="webCharge()">普通充值</el-button>
        <el-button type="primary" @click="wxCharge()">小程序充值</el-button>
      </div> -->
      <div class="poster-container" ref="imageTofile">
        <div class="poster-bg-img">
          <div class="poster-bg-mask"></div>
        </div>
        <div class="poster-content">
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { util } from "../utils/global";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  data() {
    return {
      // 生成二维码的参数
      imgsrc: "",
      shop: {},
    };
  },
  mounted() {
    this.shop = JSON.parse(sessionStorage.getItem("shopData")).shop;
    if (this.$store.state.shopData.parkInfo.payChannel == 33) {
      this.wxCharge();
    } else {
      this.webCharge();
    }
  },
  methods: {
    webCharge() {
      let placeholder =
        "http://g.zaztservice.com/park-pay/park/authorize?parkId=" +
        this.shop.parkId +
        "&fwParam=openId&plate=" +
        this.shop.id +
        "&forwardUrl=https://pay.zaztservice.com/shop_recharge.html";
      this.qrCode(placeholder);
    },
    wxCharge() {
      let placeholder = `https://pay.zaztservice.com/shopWxCharge?parkId=${this.shop.parkId}&shopId=${this.shop.id}&shopName=${this.shop.name}`;
      this.qrCode(placeholder);
    },
    qrCode(url) {
      // 点击生成图片时

      let qrcode = new QRCode("qrcode", {
        width: 255, //图像宽度
        height: 255, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H, //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
      setTimeout(() => {
        this.toImage();
      }, 500);
    },
    toImage() {
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.imageTofile, {
        backgroundColor: null,
      }).then((canvas) => {
        let url = canvas.toDataURL("image/png");
        this.imgsrc = url; // 把生成的base64位图片上传到服务器,生成在线图片地址
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import url(../assets/css/qrcode.css);
.counter {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .qrs {
    width: 88%;
    height: 80%;
    position: absolute;
    top: 80px;
    left: 200px;
    right: 0;
    bottom: -80px;
    background-color: rgba(255, 255, 255, 1);
    z-index: 99999;
    padding-top: 12vh;
    box-sizing: border-box;

    .poster-container {
      .poster-bg-img {
        width: 500px;
        height: 656px;
        background: url("../assets/re.jpg") no-repeat;
        background-size: 100%;
      }
    }

    .poster-content {
      #qrcode {
        top: 181px;
        left: 123px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/recharte.vue